import Layout from './Layout';

const AuthLayout = () => {
  return <Layout />;
};

export default AuthLayout;
